




























































































































































import { Component, Vue } from "vue-property-decorator";
import { storeKepatuhanVisiteDpjp } from "@/store/modules/KepatuhanVisiteDpjpStore";
import Service from "@/services/KepatuhanVisiteDpjpService";
import VisiteTrenChart from "@/components/kepatuhan-visite-dpjp/VisiteTrenChart.vue";

@Component({
  components: { VisiteTrenChart }
})
export default class ScorecardDpjpPage extends Vue {
  get trenLabels(): string[] {
    const tren = this.dashboard?.tren_6_bulan || [];
    return tren.map((t: any) => `${this.bulanShort(t.bulan)} ${t.tahun}`);
  }

  get trenData(): (number | null)[] {
    const tren = this.dashboard?.tren_6_bulan || [];
    return tren.map((t: any) =>
      t.capaian_persen === null || t.capaian_persen === undefined
        ? null
        : Number(t.capaian_persen)
    );
  }

  storeModule = storeKepatuhanVisiteDpjp;

  bulan: number = new Date().getMonth() + 1;
  tahun: number = new Date().getFullYear();
  loading = false;
  generating = false;

  dashboard: any = null;
  scorecards: any[] = [];

  bulanOptions = [
    { text: "Januari", value: 1 },
    { text: "Februari", value: 2 },
    { text: "Maret", value: 3 },
    { text: "April", value: 4 },
    { text: "Mei", value: 5 },
    { text: "Juni", value: 6 },
    { text: "Juli", value: 7 },
    { text: "Agustus", value: 8 },
    { text: "September", value: 9 },
    { text: "Oktober", value: 10 },
    { text: "November", value: 11 },
    { text: "Desember", value: 12 },
  ];

  scorecardHeaders = [
    { text: "Rank", value: "ranking", width: "60px", align: "center" },
    { text: "Dokter Spesialis", value: "dokter_nama" },
    { text: "Spesialisasi", value: "spesialisasi", width: "120px" },
    { text: "Session", value: "total_session", width: "70px", align: "center" },
    { text: "Pasien", value: "total_pasien_observasi", width: "70px", align: "center" },
    { text: "Numerator", value: "total_numerator", width: "80px", align: "center" },
    { text: "Denominator", value: "total_denominator", width: "90px", align: "center" },
    { text: "Capaian", value: "capaian_persen", width: "100px", align: "center" },
    { text: "Tren (3 bln)", value: "tren", width: "130px", sortable: false },
  ];

  mounted() {
    this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const [dashRes, scRes] = await Promise.all([
        Service.getDashboard(this.bulan, this.tahun),
        Service.getScorecards(this.bulan, this.tahun),
      ]);
      this.dashboard = dashRes.data.data || null;
      this.scorecards = scRes.data.data || [];
    } catch (e) {
      // Error handled by service
    }
    this.loading = false;
  }

  async generateScorecards() {
    this.generating = true;
    try {
      await Service.generateScorecards(this.bulan, this.tahun);
      await this.loadData();
    } catch (e) {
      // Error handled by service
    }
    this.generating = false;
  }

  bulanShort(b: number): string {
    const names = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
    return names[b - 1] || "";
  }
}
